// 导入封装好的网络请求类工具
import service from "./axios";

// 获取考生统计
export const getApplyInfoData = data => {
  return service({
    url: "/apply/applyDetail/countChart",
    method: "post",
    code: "v4"
  });
};

// 获取公告
export const getContentList = data => {
  return service({
    url: "/apply/index/getContentList/" + data,
    method: "post",
    code: "v4"
  });
};

// 获取近期考试
export const getExamList = data => {
  return service({
    url: "/apply/index/getExamList",
    method: "post",
    code: "v4"
  });
};

// 获取全部公告（分页）
export const getAllContentList = (data, current, size) => {
  return service({
    url: "/apply/contentInfo/getContentInfoList",
    method: "post",
    params: {
      current,
      size
    },
    data,
    code: "v4"
  });
};

// 获取全部考试（分页）
export const getAllExamList = (data, current, size) => {
  return service({
    url: "/apply/index/getExamInfoList",
    method: "post",
    params: {
      current,
      size
    },
    data,
    code: "v4"
  });
};

// 获取考试成绩
export const getExamResult = data => {
  return service({
    url: "/apply/applyDetail/getScore",
    method: "post",
    data,
    code: "v4"
  });
};



// WEBPACK FOOTER //
// ./src/api/home.js